(function () {
    var active_classname = 'is-idg18-active';
    var locked_classname = 'is-idg18-locked';

    var destroy = function () {
        var els = document.querySelectorAll('.idg18');
        for (var i = 0; i < els.length; i++) {
            els[i].parentNode.removeChild(els[i]);
        }
    };

    var create = function (url, classnames) {
        var e = document.createElement('div');
        e.classList.add('idg18');
        if (classnames) classnames.split(' ').forEach(function (classname) { e.classList.add(classname); });
        e.innerHTML = '<iframe src="' + url + '" class="idg18-frame" onload="this.classList.add(\'is-loaded\'); this.contentWindow.focus()" frameborder="0"></iframe><i class="idg18-loader"></i>';
        document.body.appendChild(e);
    };

    var open = function (url, classnames) {
        clearTimeout(window.idg18close);
        clearTimeout(window.idg18lock);
        clearTimeout(window.idg18open);
        destroy();
        create(url, classnames);
        window.idg18open = setTimeout(function () {
            window.idg18scroll = window.pageYOffset;
            document.documentElement.classList.add(active_classname);
            window.idg18lock = setTimeout(function () {
                document.documentElement.classList.add(locked_classname);
            }, 500);
        }, 25);
    };

    var close = function () {
        clearTimeout(window.idg18close);
        document.documentElement.classList.remove(locked_classname);
        window.scrollTo(0, window.idg18scroll || 0);
        document.documentElement.classList.remove(active_classname);
        window.idg18close = setTimeout(function () {
            destroy();
        }, 1000);
    };

    //***//

    window.addEventListener("message", function () {
        if (event.data == 'idg18close') close();
    }, false);

    [].forEach.call(document.querySelectorAll('[rel="idg18"]'), function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            open(event.target.getAttribute("href"), (event.target.getAttribute("data-theme") || false));
        });
    });

})();
